// ============================================================
// GLOBAL.JS — Feals-inspired Shopify Theme
// ============================================================

// ---- Sticky Header ----
(function() {
  const header = document.querySelector('.site-header');
  if (!header) return;
  let lastScroll = 0;
  window.addEventListener('scroll', () => {
    const currentScroll = window.scrollY;
    if (currentScroll > 60) {
      header.classList.add('scrolled');
    } else {
      header.classList.remove('scrolled');
    }
    lastScroll = currentScroll;
  }, { passive: true });
})();

// ---- Mobile Menu ----
(function() {
  const toggle = document.querySelector('.mobile-menu-toggle');
  const nav = document.querySelector('.header-nav');
  if (!toggle || !nav) return;
  toggle.addEventListener('click', () => {
    const open = nav.classList.toggle('open');
    toggle.setAttribute('aria-expanded', open);
  });
  document.addEventListener('click', (e) => {
    if (!e.target.closest('.site-header')) {
      nav.classList.remove('open');
      toggle.setAttribute('aria-expanded', false);
    }
  });
})();

// ---- Accordion / FAQ ----
function initAccordions(selector) {
  document.querySelectorAll(selector).forEach(item => {
    const trigger = item.querySelector('[data-accordion-trigger]');
    if (!trigger) return;
    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      // Close siblings
      item.closest('[data-accordion-group]')?.querySelectorAll(selector).forEach(sibling => {
        sibling.classList.remove('open');
      });
      if (!isOpen) item.classList.add('open');
    });
  });
}
initAccordions('.faq-item');
initAccordions('.product-tab');

// ---- Product Gallery ----
(function() {
  const gallery = document.querySelector('.product-gallery');
  if (!gallery) return;
  const mainImg = gallery.querySelector('.product-gallery__main img');
  const thumbs = gallery.querySelectorAll('.product-gallery__thumb');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      const src = thumb.querySelector('img').src;
      const srcset = thumb.querySelector('img').srcset;
      if (mainImg) {
        mainImg.src = src;
        if (srcset) mainImg.srcset = srcset;
      }
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
    });
  });
})();

// ---- Purchase Type Toggle ----
(function() {
  const options = document.querySelectorAll('.purchase-type__option');
  options.forEach(option => {
    option.addEventListener('click', () => {
      options.forEach(o => o.classList.remove('selected'));
      option.classList.add('selected');
      const radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
      // Trigger change event for form updates
      option.dispatchEvent(new Event('change', { bubbles: true }));
    });
  });
})();

// ---- Ingredients Tabs ----
(function() {
  const tabBtns = document.querySelectorAll('.ingredients-tab-btn');
  tabBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      const target = btn.dataset.tab;
      tabBtns.forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      document.querySelectorAll('.ingredients-tab-content').forEach(content => {
        content.classList.toggle('active', content.dataset.tab === target);
      });
    });
  });
})();

// ---- Variant Selector ----
class VariantSelector extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.updateAddButton(true, '', false);
    this.updatePickupAvailability();

    if (!this.currentVariant) {
      this.updateAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      } else {
        return Array.from(element.querySelectorAll('input')).find(radio => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find(variant => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant?.featured_media) return;
    const mediaGallery = document.querySelector('.product-gallery');
    if (!mediaGallery) return;
    const thumbs = mediaGallery.querySelectorAll('.product-gallery__thumb');
    thumbs.forEach(thumb => {
      if (thumb.dataset.mediaId === String(this.currentVariant.featured_media.id)) {
        thumb.click();
      }
    });
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach(productForm => {
      const input = productForm.querySelector('input[name="id"]');
      if (input) input.value = this.currentVariant?.id || '';
      input?.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateAddButton(disable, text, modifyClass) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;
    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text !== '') addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }
    if (!modifyClass) return;
    addButton.classList.toggle('sold-out', !this.currentVariant?.available);
  }

  updatePickupAvailability() {}

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`)?.querySelector('[name="add"]');
    const addButtonText = button?.querySelector('> span');
    if (!button) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    button.setAttribute('disabled', 'disabled');
  }

  renderProductInfo() {
    const priceEl = document.querySelector('.product-price');
    if (priceEl && this.currentVariant) {
      const price = (this.currentVariant.price / 100).toFixed(2);
      const comparePrice = this.currentVariant.compare_at_price;
      priceEl.innerHTML = comparePrice && comparePrice > this.currentVariant.price
        ? `<s>$${(comparePrice / 100).toFixed(2)}</s> <span class="price--sale">$${price}</span>`
        : `$${price}`;
    }
    this.updateAddButton(!this.currentVariant?.available, this.currentVariant?.available ? '' : window.variantStrings.soldOut, false);
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define('variant-selector', VariantSelector);

// ---- Slider / Carousel ----
class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[data-slider]');
    this.prevBtn = this.querySelector('[data-prev]');
    this.nextBtn = this.querySelector('[data-next]');
    if (!this.slider) return;
    this.init();
  }

  init() {
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.scroll(-1));
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.scroll(1));
  }

  scroll(direction) {
    const scrollAmount = this.slider.offsetWidth * 0.85;
    this.slider.scrollBy({ left: direction * scrollAmount, behavior: 'smooth' });
  }
}
customElements.define('slider-component', SliderComponent);
